<template>
  <div>
    
    <table-widget :items="grants" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
      <template slot="buttons">
        <slot name="grant-buttons"/>
      </template>
      <template slot="content">
        <b-table striped
                :items="grants"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                @filtered="onFiltered"
                small
                show-empty
                :tbody-transition-props="transProps"
                empty-filtered-text="There are no grants that match your search criteria.">
          <template v-slot:cell(grant)="data">
          {{ data.item.description }}
          </template>
          <template v-slot:cell(percentage)="data">
            {{ data.item.percentage }} %
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade",
      },
      items: [],
      fields: [{ key: "grant", label: "Grant" }],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedGrants: [],
    };
  },

  props: {
    grants: {
      type: Array,
      required: true,
      default: function() {
        return [];
      },
    },
    manage: {
      type: Boolean,
      required: false,
      default: function() {
        return false;
      },
    },
  },

  components: { "table-widget": TableWidget },

  computed: {},

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },

  watch: {
    buyouts: function() {
      if (this.grants.length) {
        this.selectedGrants = this.grants;
        this.totalRows = this.buyouts.length;
      }
    },
  },

  created() {
    if (this.grants.length) {
      this.selectedGrants = this.grants;
      this.totalRows = this.grants.length;
    }
    if (this.manage) {
      this.fields.push({ key: "notes", label: "Notes" });
    }
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
